import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header variant={isHomePage ? 'dark' : 'light'} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
